import { ref, watch, onMounted, onBeforeUnmount } from 'vue'
import { useAccessibilityStore } from '@/stores/accessibility'

/**
 * Mobile breakpoint that tracks the a11y text scale.
 * `remThreshold * 16` ≈ former `max-width: Npx` when scale is 100%.
 * At 125%/150% the threshold is raised so chrome collapses before nav overflows.
 */
export function useIsMobile(remThreshold = 48) {
  const isMobile = ref(false)
  const a11yStore = useAccessibilityStore()

  function check() {
    // Не читаем computed font-size: на iOS он может быть уже раздут, и порог
    // уедет вместе с ним. Номинальные 16px × выбранный масштаб.
    const scale = a11yStore.fontScale / 100
    const rootFont = 16 * scale
    const scaleBoost = a11yStore.fontScale >= 150 ? 12 : a11yStore.fontScale >= 125 ? 6 : 0
    isMobile.value = window.innerWidth < (remThreshold + scaleBoost) * rootFont
  }

  onMounted(() => {
    check()
    window.addEventListener('resize', check)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', check)
  })

  watch(() => a11yStore.fontScale, check)

  return isMobile
}
